// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Baruch",
  bookSlug: "baruch",
  chapter: 5,
  argument: "Jerusalem is invited to rejoice, and behold the return of her children out of their captivity.",
  verses: [
    { n: 1, text: "Put off, O Jerusalem, the garment of thy mourning, and affliction: and put on the beauty, and honour of that everlasting glory which thou hast from God." },
    { n: 2, text: "God will clothe thee with the double garment of justice, and will set a crown on thy head of everlasting honour." },
    { n: 3, text: "For God will shew his brightness in thee, to every one under heaven." },
    { n: 4, text: "For thy name shall be named to thee by God for ever: the peace of justice, and honour of piety." },
    { n: 5, text: "Arise, O Jerusalem, and stand on high: and look about towards the east, and behold thy children gathered together from the rising to the setting sun, by the word of the holy One, rejoicing in the remembrance of God." },
    { n: 6, text: "For they went out from thee on foot, led by the enemies: but the Lord will bring them to thee, exalted with honour, as children of the kingdom." },
    { n: 7, text: "For God hath appointed to bring down every high mountain, and the everlasting rocks, and to fill up the valleys, to make them even with the ground: that Israel may walk diligently to the honour of God." },
    { n: 8, text: "Moreover, the woods, and every sweet-smelling tree, have overshadowed Israel, by the commandment of God." },
    { n: 9, text: "For God will bring Israel with joy in the light of his majesty, with mercy, and justice, that cometh from him." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Garment. Hebrew, \"cloak,\" (Sanctius) such as were worn by people under no disgrace, chap. iv. 20. Thamar had one very costly, 2 Kings xiii. 18. (Calmet) — Justice, or mercy. God is bound to fulfill his gracious promises.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "His. Greek, \"thy.\" Christ, the sun of justice, would effect this, Isaias lx. 1.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Piety. Thus shall Jerusalem be distinguished after the captivity; but still more so when Christ shall appear, and give peace to his Church, after the ages of persecution.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Arise. Chap. iv. 36., and Isaias lii. 2. — God. They remember his law with pleasure.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Children. Greek, \"the throne.\" The return of the captives was a triumph, Isaias xlvi. 20., and xlix. 22. They had abundance of horses, &c., 1 Esdras ii. 66. Darius gave them a convoy of 1000 horsemen. (3 Esdras v. 2.)", attribution: "Josephus, Antiquities xi. 4." }
    ] },
    { verse: 7, notes: [
      { text: "Diligently, without stumbling under the pillar of God's protection, Isaias xl. 3. (Calmet) Ad vos qua veniet, tumidi subsidite montes Et faciles curvis vallibus este vi�.", attribution: "Ovid, Am. ii. 16." }
    ] },
    { verse: 8, notes: [
      { text: "Woods. This is a poetical description. They shall pass through the sands of Arabia, as if they were under a delightful shade.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
